(() => {
  const sectionSelector = '[data-thom-fit-film]';

  function initSection(section) {
    if (!section || section.dataset.thomFitFilmReady === 'true') return;

    const video = section.querySelector('video');
    const playButton = section.querySelector('[data-thom-fit-play]');
    if (!video || !playButton) return;

    section.dataset.thomFitFilmReady = 'true';

    playButton.addEventListener('click', async () => {
      video.controls = true;

      try {
        await video.play();
      } catch (error) {
        video.controls = true;
      }
    });

    video.addEventListener('play', () => {
      playButton.hidden = true;
    });

    video.addEventListener('pause', () => {
      if (video.currentTime === 0 || video.ended) playButton.hidden = false;
    });

    video.addEventListener('ended', () => {
      playButton.hidden = false;
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
